module.exports = __webpack_public_path__ + "media/images/nl/upload-confirmation-fb10bf913e2034c9d8fab2e346dc9bfb.png";